import React, { ReactElement } from "react";
import Styles from "./SquareIcon.module.scss";

export default function SquareIcon(props: {
    children?: ReactElement | ReactElement[] | string | string[];
    size?: "sm" | "md" | "lg";
    className?: string;
}) {
    return (
        <span className={`bg-button rounded text-white text-center d-inline-block ${props.className} ${
            Styles[`square-icon-${props.size}`] ?? ""}`}
        >
            {props.children}
        </span>
    );
}

SquareIcon.defaultProps = {
    children: undefined,
    className: "",
    size: "sm",
};
